import type { FieldValueType } from '@helpcenter/field-types';
import { format as dateFnsFormat } from 'date-fns';
import type { ForgeFieldAdditionalProps, DefaultUser } from 'state/persisted/request-create/types';

export const forgeFieldParamsParser = (
    fieldType: string | undefined,
    collectionType: string | undefined,
    defaultObject: unknown,
    defaultList: unknown[]
): { value: FieldValueType; additionalProps: ForgeFieldAdditionalProps } => {
    let value: FieldValueType;
    let additionalProps: ForgeFieldAdditionalProps = {};

    switch (fieldType) {
        case 'string':
            if (collectionType === 'list') {
                value = defaultList as string[];
                additionalProps = {
                    // String list is rendered as label picker
                    defaultLabels: (value as string[]).map((labelStr) => ({
                        label: labelStr,
                        value: labelStr,
                    })),
                };
            } else {
                value = defaultObject as string;
            }
            break;

        case 'number':
            value = defaultObject as number;
            break;

        case 'date':
            value = defaultObject
                ? dateFnsFormat(new Date(defaultObject as string | number | Date), 'yyyy-MM-dd')
                : undefined;
            additionalProps = {
                defaultDate: value,
            };

            break;

        case 'datetime':
            value = defaultObject
                ? dateFnsFormat(new Date(defaultObject as string | number | Date), "yyyy-MM-dd'T'HH:mm")
                : undefined;
            additionalProps = {
                defaultDate: value,
            };

            break;

        case 'user':
            if (collectionType === 'list') {
                value = (defaultList as { id: string }[]).map((u) => u.id).join(',');
                additionalProps = {
                    defaultUsers: defaultList as DefaultUser[],
                };
            } else {
                value = defaultList ? (defaultList as { id: string }[])[0].id : undefined;
                additionalProps = {
                    defaultUser: defaultList[0] as DefaultUser,
                };
            }
            break;

        default:
            value = null;
            break;
    }

    return { value, additionalProps };
};
